import { Codebook } from '../Codebook'

export enum ThreadChannelTypeId {
  AIRBNB = 1262,
  BOOKING_COM = 770,
  EXPEDIA = 754,
}

export class ThreadChannelType extends Codebook<ThreadChannelTypeId> {
  static readonly AIRBNB = new ThreadChannelType(ThreadChannelTypeId.AIRBNB, () => 'Airbnb')
  static readonly BOOKING_COM = new ThreadChannelType(
    ThreadChannelTypeId.BOOKING_COM,
    () => 'Booking.com',
  )
  static readonly EXPEDIA = new ThreadChannelType(ThreadChannelTypeId.EXPEDIA, () => 'Expedia')

  private constructor(
    public readonly id: ThreadChannelTypeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
